




























import {
  defineComponent,
  useRoute,
  computed,
  ref,
  onBeforeMount,
  Ref,
} from '@nuxtjs/composition-api';
import { TypeDisplay, TabControls } from '@bambeehr/pollen';
import HeadingContainer from '@/modules/About/components/HeadingContainer.vue';
import useAbout from '@/modules/About/hooks/useAbout';
import Analytics from '@/services/Analytics';
import Contentful from '@/services/Contentful';
import TheFooter from '@/components/Navigation/TheFooter.vue';
import HomeNav from '@/modules/HomePage/components/Navigation/HomeNav.vue';
const ABOUT_NAV_CONTENTFUL_ID = '5mHr5X86x1FjWhv2Zeq96r';

const handleSeeRoles = () => {
  if (window !== undefined) {
    window.open('https://boards.greenhouse.io/bambee', '_blank');
  }
  Analytics.track('user-check-roles');
};

interface ITab {
  label: string;
  value: string;
}

export default defineComponent({
  name: 'AboutRoot',
  components: {
    HeadingContainer,
    TypeDisplay,
    TabControls,
    TheFooter,
    HomeNav,
  },
  layout: 'empty',
  setup() {
    const route = useRoute();
    const tabData: Ref<ITab[]> = ref([]);
    const isReady = ref(false);

    onBeforeMount(() => {
      const fetchData = async (): Promise<void> => {
        await Contentful.getEntry(ABOUT_NAV_CONTENTFUL_ID).then(
          ({ fields }) => {
            tabData.value = fields.navLabel.map((item) => {
              return {
                label: item.fields.navLabel,
                value: item.fields.navLabel.toLowerCase().replace(' ', '-'),
              };
            });
            isReady.value = true;
          }
        );
      };
      fetchData();
    });

    const { goToPage, pageIndex, header } = useAbout();

    const currentPage = computed(() => {
      switch (route.value.path.split('/')[1]) {
        case 'culture':
          return 'Culture';
        case 'hr-managers':
          return 'HR Managers';
        case 'leadership':
          return 'Leadership';
        case 'investors':
          return 'Investors';
        case 'teams':
          return 'Teams';
        // case 'benefits':
        //   return 'Benefits';
        default:
          return 'About';
      }
    });

    const handleTabChange = (e) => {
      goToPage(e);
      window.scrollTo(0, 0);

      Analytics.track('about-bambee-tab-change', {
        page: pageIndex.value.label,
        timestamp: new Date(),
      });
    };

    return {
      currentPage,
      tabData,
      handleTabChange,
      header,
      pageIndex,
      isReady,
      handleSeeRoles,
    };
  },
});
